import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { InputWhite } from "@UI/New/InputWhite";
import s from './index.module.css';

export const LinkToMeetingForChildren = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
        <InputWhite 
            value={state.link_to_meeting_for_children}
            placeholder='Вставьте ссылку на встречу(Для учащихся)'
            onChange={value => setFieldInState({field: 'link_to_meeting_for_children', value})}
            className={s.input}
        />
    )
}